<template>
    <v-app>
        <v-container>
            <v-row justify="center" style="height: 400px">
                <v-col cols="9" align-self="center">
                    <v-file-input
                        v-model="ficheroIndicadores"
                        accept=".xlsx"
                        label="Excel de indicadores"
                        show-size
                        truncate-length="50"
                    >
                    </v-file-input>
                    <v-btn
                        color="primary"
                        elevation="2"
                        right
                        @click="enviarFichero"
                        :disabled="!existeFichero"
                    >
                        Subir fichero
                    </v-btn>

                    <div v-if="mensajes">
                        <v-alert
                            v-if="mensajes.length > 0"
                            dense
                            outlined
                            :type="esError ? 'error' : 'success'"
                            class="mt-4"
                        >
                            {{ esError ? "Errores:" : "Se han modificado:" }}
                            <br />
                            <ul>
                                <li v-for="mensaje in mensajes">
                                    {{ mensaje }}
                                </li>
                            </ul>
                        </v-alert>
                        <v-alert v-else dense outlined type="success" class="mt-4">
                            No se ha modicado nada
                        </v-alert>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import FicherosService from "@services/FicherosService";

export default {
    name: "subirIndicadores",
    data: () => ({
        ficheroIndicadores: null,
        mensajes: null,
        esError: false,
    }),
    computed: {
        existeFichero() {
            return !!this.ficheroIndicadores;
        },
    },
    methods: {
        enviarFichero() {
            this.mensajes = null;
            this.esError = false;
            FicherosService.subirFichero(this.ficheroIndicadores)
                .then((response) => {
                    this.mensajes = response.data;
                })
                .catch((error) => {
                    this.esError = true;
                    this.mensajes = [].concat(
                        ...Object.values(error.response.data.errors)
                    );
                });
        },
    },
};
</script>
